module.exports = __webpack_public_path__ + "img/alert_danger.f8016eca.svg";